import { Component, EventEmitter, HostListener, Output } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { NavigationEnd, Router } from '@angular/router';
import { SideBarService } from '../../shared/services/common/side-bar.service';

@Component({
  selector: 'app-menu-layout',
  templateUrl: './menu-layout.component.html',
  styleUrls: ['./menu-layout.component.scss'],
})
export class MenuLayoutComponent {
  items: MenuItem[] | undefined;
  @Output() filterChanged = new EventEmitter<any>();
  tableData: any = [];
  isMobileView: boolean = false
  public isHovered = false;
  searchText: string = '';
  filteredMenu: any[] = [];
  noMenuFound: boolean = false;


  public styleData = {
    width: '45px',
    top: '0vh',
    minWidth: '0px',
    transition: '0.3s ease-in-out',
  };

  constructor(private router: Router, private sidebarService: SideBarService) {}

  ngOnInit() {
    this.checkScreenSize();
    this.getMenu();
    if(this.isMobileView){
      this.updateSidebarStyle();
    }
  }

   @HostListener('window:resize')
    onResize() {
      this.checkScreenSize();
    }
  
    private checkScreenSize() {
      this.isMobileView = window.innerWidth < 768;
    }
  onMouseEnter() {
    this.isHovered = true;
    this.styleData = {
      width: '20vw',
      top: '0vh',
      minWidth: '250px',
      transition: '0.3s ease-in-out',
    };
  }

  onMouseLeave() {
    this.isHovered = false;
    this.styleData = {
      width: '45px',
      top: '0vh',
      minWidth: '0px',
      transition: '0.3s ease-in-out',
    };
    this.tableData.forEach((a) => {
        a.active = false;
    });
  }

  getIconClass(icon: string): string {
    const iconMap = {
      'message-circle': 'pi pi-comment',
      layers: 'pi pi-th-large',
      award: 'pi pi-crown',
      archive: 'pi pi-ticket',
      speaker: 'pi pi-megaphone',
      pocket: 'pi pi-gauge',
      'book-open': 'pi pi-receipt',
      framer: 'pi pi-inbox',
      film: 'pi pi-sparkles',
      'briefcase': 'pi pi-briefcase',
    };

    return iconMap[icon] || `pi pi-${icon}`;
  }

  getMenu() {
    this.sidebarService.fetchMenu().subscribe((res) => {
      let menuItems = res['data'];
      this.tableData = res['data'];
      this.tableData = res['data'];
      this.filteredMenu = [...this.tableData];
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          menuItems.filter((items) => {
            if (items.path === event.url) {
              this.setNavActive(items);
              if (items.children) {
                items.children.filter((subItems) => {
                  if (subItems.path === event.url) {
                    this.setNavActive(subItems);
                  }
                  if (subItems.children) {
                    subItems.children.filter((subSubItems) => {
                      if (subSubItems.path === event.url) {
                        this.setNavActive(subSubItems);
                      }
                    });
                  }
                });
              }
            }
          });
        }
      });
    });
  }

  setNavActive(item) {
    this.tableData.filter((menuItem) => {
      if (menuItem != item) menuItem.active = false;
      if (menuItem.children && menuItem.children.includes(item))
        menuItem.active = true;
      if (menuItem.children) {
        menuItem.children.filter((submenuItems) => {
          if (submenuItems.children && submenuItems.children.includes(item)) {
            menuItem.active = true;
            submenuItems.active = true;
          }
        });
      }
    });
  }

  navigateTo(route: string) {
    this.router.navigateByUrl(route);
  }

  toggleNavActive(child, parent) {
    //console.log(child, parent);
    
    if (!child.active) {
      this.tableData.forEach((a) => {
        if (a.title != parent.title) {
          a.active = false;
        }
        if (a.children) {
          a.children.forEach((b) => {
            if (a.title != child.title) {
              b.active = false;
            }
            if (b.children) {
              b.children.forEach((c) => {
                c.active = false;
              });
            }
          });
        }
      });
    }

    child.active = !child.active;
  }

  toggleMainActive(item) {
    if (!item.active) {
      this.tableData.forEach((a) => {
        if (a.title != item.title) {
          a.active = false;
        }
      });
    }
    item.active = !item.active;
  }

  //mobile view ts code start from here
  sidebarVisible = false;
  sidebarStyle = {};
  updateSidebarStyle() {
    this.sidebarStyle = {
      width: this.sidebarCollapsed ? '45px' : '250px',
      minWidth: this.sidebarCollapsed ? '45px' : '250px',
      transition: '0.3s ease-in-out'
    };
  }

  sidebarCollapsed: boolean = true;
  toggleSidebar() {
    this.sidebarCollapsed = !this.sidebarCollapsed;
    this.updateSidebarStyle();
    if (this.sidebarCollapsed) {
      this.tableData.forEach(a => a.active = false);
    }
  }

  onSidebarOutsideClick() {
    if (!this.sidebarCollapsed) {
      this.sidebarCollapsed = true;
    }
  }

  onChildMenuClick() {
    if (!this.sidebarCollapsed) {
      this.sidebarCollapsed = true;
      this.updateSidebarStyle();
    }
  }

  filterMenu() {
  const search = this.searchText?.toLowerCase().trim();

  if (!search) {
    this.filteredMenu = [...this.tableData];
    this.noMenuFound = false;
    return;
  }

  this.filteredMenu = this.tableData
    .map(menu => {

      const parentMatch = menu.title?.toLowerCase().includes(search);

      const childrenMatch = menu.children?.filter(child =>
        child.title?.toLowerCase().includes(search)
      );

      if (parentMatch) {
        return { ...menu, active: true };
      }

      if (childrenMatch && childrenMatch.length > 0) {
        return {
          ...menu,
          active: true,
          children: childrenMatch
        };
      }
      return null;
    })
    .filter(Boolean);
  this.noMenuFound = this.filteredMenu.length === 0;
}


}
